import { css } from 'linaria';
import { styled } from 'linaria/react';

export const CityPickerRoot = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;

  button {
    align-items: flex-end;
    white-space: nowrap;

    & > div {
      display: flex;
      flex-direction: column;
      align-items: baseline;
    }
  }

  @media (--only-mobile) {
    padding-left: var(--space-150);
    button {
      transform: translateY(1px);
    }
  }
`;

export const cityPickerLabel = css`
  transform: translateY(-1px);
`;

export const popoverClassName = css`
  box-sizing: content-box;
`;

export const hoveredText = css`
  display: block;
  max-width: 188px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const hover = css`
  &:hover {
    background-color: initial !important;
    box-shadow: initial !important;

    .${hoveredText} {
      color: var(--brand-dark);
    }

    path {
      --i-color: var(--brand-dark);
    }
  }
`;

export const favoriteAddressLayout = css`
  min-width: 0;

  & > div {
    @media (--only-mobile) {
      width: 100%;
    }
  }

  button {
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    min-width: 0;

    & > div {
      min-width: 0;
      text-align: left;
    }

    @media (--only-mobile) {
      width: 100%;
    }
  }

  .${hoveredText} {
    @media (--only-mobile) {
      width: 100%;
      max-width: none;
    }
  }
`;

export const actionButton = css`
  width: 100%;
`;
